// @ts-nocheck
// app/+not-found.tsx — Editorial 404
import Head from 'expo-router/head';
import { Stack, useRouter } from 'expo-router';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { ArrowLeft } from 'lucide-react-native';

import { theme, ACCENT, INK, INK_MUTED, INK_SOFT, PAPER, PAPER_SOFT } from '@/constants/theme';
import { EditorialButton, EditorialFooter, Eyebrow, Headline, Numeral, Paper, Section } from '@/components/editorial';
import { EditorialHeader } from '@/components/editorial/EditorialHeader';

const SERIF_BLACK = theme.fonts.serifBlack;
const SERIF = theme.fonts.serif;
const SANS = theme.fonts.regular;
const MONO = theme.fonts.mono;
const IS_WEB = Platform.OS === 'web';

export default function NotFoundScreen() {
  const router = useRouter();
  return (
    <>
      <Stack.Screen options={{ title: 'דף לא נמצא' }} />
      {IS_WEB && (
        <Head>
          <title>404 · דף לא נמצא · Kursi</title>
          <meta name="robots" content="noindex,nofollow" />
        </Head>
      )}

      <Paper>
        <EditorialHeader />

        <Section py="xxl" px="md" max={900}>
          <View style={{ alignItems: 'center' }}>
            <Text style={s.tag}>סטופ פרס · אזהרת עורך</Text>
            <View style={{ height: 18 }} />
            <Text style={s.bigNum}>404</Text>
            <View style={{ height: 12 }} />
            <Headline level={1} align="center">העמוד הזה לא קיים.</Headline>
            <View style={{ height: 16 }} />
            <Text style={s.lede}>
              יכול להיות שהקישור שגוי, שהעמוד הועבר, או שמישהו פה במערכת עוד לא הגיש את הכתבה.{'\n'}
              בכל מקרה — יש לכם איפה לחזור.
            </Text>
            <View style={{ height: 32 }} />
            <View style={{ flexDirection: 'row-reverse', gap: 14, flexWrap: 'wrap' } as any}>
              <EditorialButton label="חזרה לעמוד הראשי" onPress={() => router.replace('/')} variant="primary" size="lg" trailing={<ArrowLeft size={16} color={PAPER} />} />
              <EditorialButton label="פתחו את הצ׳אט" onPress={() => router.push('/chat')} variant="secondary" size="lg" />
            </View>
          </View>
        </Section>

        <EditorialFooter onNavigate={(href) => router.push(href as any)} />
      </Paper>
    </>
  );
}

const s = StyleSheet.create({
  tag: { fontFamily: MONO, fontSize: 11, color: ACCENT, letterSpacing: 2.2, textTransform: 'uppercase' as any },
  bigNum: { fontFamily: SERIF_BLACK, fontSize: IS_WEB ? 240 : 140, color: INK, lineHeight: IS_WEB ? 220 : 130, letterSpacing: -8 },
  lede: { fontFamily: SERIF, fontSize: 19, color: INK_SOFT, lineHeight: 30, textAlign: 'center', maxWidth: 560 },
});
